import { getPaginatedCodelistUrl } from "../../../../../constants/urls";
import { postRequest } from "../../../../../middlewares/api/actions";

export const FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_FORM_SHOW = 'FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_FORM_SHOW';
export const FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_FORM_HIDE = 'FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_FORM_HIDE';
export const FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_TYPE_SET = 'FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_TYPE_SET';
export const FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_VALUE_SET = 'FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_VALUE_SET';
export const FILE_MAPPING_WIZARD_COMPONENT_LIST_CODELIST_CODES_ITEMS_PAGE_READ = 'FILE_MAPPING_WIZARD_COMPONENT_LIST_CODELIST_CODES_ITEMS_PAGE_READ';
export const FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_SAVE = 'FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_SAVE';

export const showComponentValueDefinitionForm = (component) => ({
    type: FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_FORM_SHOW,
    component
  });
  
export const hideComponentValueDefinitionForm = () => ({
type: FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_FORM_HIDE
});

export const setComponentValueDefinitionType = (valueDefinitionType, cubeComponents) => ({
  type: FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_TYPE_SET,
  valueDefinitionType,
  cubeComponents
});

export const setComponentValueDefinitionValue = (value) => ({
  type: FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_VALUE_SET,
  value
});

export const saveComponentValueDefinition = () => ({
  type: FILE_MAPPING_WIZARD_COMPONENT_LIST_VALUE_DEFINITION_SAVE,
});


export const readComponentCodelistCodesItemsPage = ({
    codelistTriplet,
    language,
    pageNum,
    pageSize,
    searchText,
    filters,
    sortCol,
    sortByDesc,
    componentName
  }
) => ({
  ...postRequest(
    FILE_MAPPING_WIZARD_COMPONENT_LIST_CODELIST_CODES_ITEMS_PAGE_READ,
    getPaginatedCodelistUrl(),
    ({
      Id: codelistTriplet.id,
      AgencyId: codelistTriplet.agencyID,
      Version: codelistTriplet.version,
      Lang: language,
      PageNum: pageNum,
      PageSize: pageSize,
      AllSearch: searchText,
      CodeSearch: filters.id ? filters.id : undefined,
      NameSearch: filters.name ? filters.name : undefined,
      ParentSearch: filters.parent ? filters.parent : undefined,
      SortColumn: sortCol ? sortCol : undefined,
      SortDesc: sortByDesc ? sortByDesc : undefined,
      rebuildDb: false
    })
  ),
  componentName
});
